module.exports = ".hand {\r\n    border: 2px solid black;\r\n}\r\n\r\nimg {\r\n    width: 130px;\r\n    height: 180px;\r\n}\r\n\r\nb {\r\n    font-size: 30px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/videopoker/videopoker.component.css
// module id = ./src/app/videopoker/videopoker.component.css
// module chunks = main